import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../src/config/authAxios"



const initialState = { status: null, message: "", loading: false, data: [], error: "" }


export const getAllChallenges = createAsyncThunk(
    'get-all-challenge',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/users/api/get-challenges`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getAllChallengesSlice = createSlice({
    name: 'get-all-challenge',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAllChallenges.pending, (state) => {
                state.data = []
                state.loading = true
            })
            builder.addCase(getAllChallenges.fulfilled, (state, action) => {
                state.data = action.payload.data
                state.loading = false
                state.message = action.payload.message
                state.status = action.payload.status
            })
            builder.addCase(getAllChallenges.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload.error
                state.message = action.payload.message
                state.status = action.payload.status
            })
        },

})



export const getChallengrReducer = getAllChallengesSlice.reducer